
const getLocationOption = (id, name) => ({
	id,
	value: id,
	label: name
});

export { getLocationOption };